import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const radio = event.target
    if (radio.dataset.wasChecked === "true") {
      radio.checked = false
      radio.dataset.wasChecked = "false"
    } else {
      this.element.querySelectorAll(".zone-radio").forEach(r => r.dataset.wasChecked = "false")
      radio.dataset.wasChecked = "true"
    }
  }
}
